import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeDate, getPractice } from "../../../../helpers";
import { fetchSinglePatientSurverForm } from "../../../../services/forms";

export default function PatientSurveyPrint({ ...props }) {
  const {    
    formViewId,
    formViewSize = "A4",
    setFormView = () => {}
  } = props;

  const [formData, setFormData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountId = getPractice("account_id");
  const locationId = getPractice("location_id");

  let formId = formViewId;
  let formSize = formViewSize;
  if (queryParams.get('form_id')) {
    formId = queryParams.get('form_id');
    formSize = queryParams.get('size');
  } 

  useEffect(() => {
    if(formId !== null){
      getReferralData( formId );
    } else {
      navigate(-1);
    }
  }, [formId]);

  const getReferralData = async ( formId ) => {
    const response = await fetchSinglePatientSurverForm( accountId, locationId, formId );
    if (response) {
      if(response.data === null) {
        window.close();
      }
      setFormData(response?.data);
      setIsDataLoaded(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    if (isDataLoaded && queryParams.get('form_id')) {
      handlePrint();
    }
  }, [isDataLoaded, queryParams]);

  const handleCloseWindow = () => {
    window.close();
  };

  const handleFormPrint = (formId) => {
    setFormView();
    const url = `/forms/patient-survey-form/print?form_id=${formId}&size=A4`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);

  useDocumentTitle("Patient Survey Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div>
          <h3 className="text-center pb-2 docpro_fs_28"><u>Patient Feedback Survey</u></h3>

          <div className="docpro_sp_section_1 docpro_grid_gap_4">
            <div className="px-0">
              <ul className="docpro_list_1">
                <li className="flex items-center pb-1" style={{ flexWrap: 'wrap' }}>
                  <p className="mb-0 pe-3 fw-bold">Patient Gender</p><span className="mx-1 mr-2">:</span> 
                  <input className="form-check-input" type="checkbox" checked={formData?.gender == 1} disabled />
                  <span className="pr-2 mr-2">Male</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.gender == 2} disabled />
                  <span className="pr-2 mr-2">Female</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.gender == 3} disabled />
                  <span className="mr-2">Transgender</span>
                </li>
                <li className="flex items-center pb-1">
                  <p className="mb-0 pe-3 fw-bold">Health Insurance</p><span className="mx-1 mr-2">:</span> 
                  <input className="form-check-input" type="checkbox" checked={formData?.insurance == 1} disabled />
                  <span className="pr-2 mr-2">Yes</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.insurance == 2} disabled />
                  <span className="mr-2">No</span>
                </li>
                <li className="flex items-center pb-1" style={{ flexWrap: 'wrap' }}>
                  <p className="mb-0 pe-3 fw-bold">Type of Health Insurance</p><span className="mx-1 mr-2">:</span> 
                  <input className="form-check-input" type="checkbox" checked={formData?.insurance_type == 1} disabled />
                  <span className="pr-2 mr-2">Medicaid</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.insurance_type == 2} disabled />
                  <span className="mr-2">Commercial</span>
                </li>
                <li className="flex items-center pb-1" style={{ flexWrap: 'wrap' }}>
                  <p className="mb-0 pe-3 fw-bold">Survey completed by</p><span className="mx-1 mr-2">:</span> 
                  <input className="form-check-input" type="checkbox" checked={formData?.com_survey == 1} disabled />
                  <span className="pr-2 mr-2">Patient</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.com_survey == 2} disabled />
                  <span className="pr-2 mr-2">Family/Caregiver</span>
                  <input className="form-check-input" type="checkbox" checked={formData?.com_survey == 3} disabled />
                  <span className="mr-2">Other</span>
                </li>
              </ul>
            </div>
            <div className="px-0">
              <ul className="docpro_list_1">
                <li className="flex" style={{ marginBottom: 0 }}>
                  <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 90 }}>Location</p><span className="mx-1">:</span>{formData?.location_id}
                </li>
                <li className="pt-0 flex" style={{ marginBottom: 0 }}>
                  <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 90 }}>Visiting date</p><span className="mx-1">:</span>{exchangeDate(formData?.visit_date)}
                </li>
                <li className="pt-0 flex" style={{ marginBottom: 0 }}>
                  <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 90 }}>Patient Name</p><span className="mx-1">:</span>{formData?.last_name} {formData?.first_name}
                </li>
                <li className="pt-0 flex" style={{ marginBottom: 0 }}>
                  <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 90 }}>DOB</p><span className="mx-1">:</span>{exchangeDate(formData?.dob)}
                </li>
                <li className="pt-0 flex" style={{ marginBottom: 0 }}>
                  <p className="mb-0 pe-3 fw-bold" style={{ minWidth: 90 }}>Provider</p><span className="mx-1">:</span>{formData?.provider}
                </li>
              </ul>
            </div>
          </div>

          <div className="docpro_table_1 hipaa_table mt-4 docpro_table_responsive" style={{ boxShadow: 'none', borderRadius: 0, paddingBottom: 0, overflowX: 'auto' }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)', borderTop: 'none' }}>
                    <p className="mb-0"><b className="me-2">1.</b> Are you/family/caregiver able to see your doctor when you need to?</p>
                  </td>
                  <td style={{ borderTop: 'none' }}>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_1 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_1 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_1 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">2.</b> Can you/family/caregiver be seen on the same day that you call for an appointment?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_2 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_2 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_2 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">3.</b> Do you/family/caregiver know that there is a phone number that you can call to receive medical advice from the doctor after regular business hours?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_3 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_3 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_3 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">4.</b> When you/family/caregiver call your doctor with a medical question, do you get an answer on that same day?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_4 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_4 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_4 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">5.</b> The practice space is clean and inviting?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_5 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_5 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_5 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">6.</b> Does your doctor explain things in a way that is easy to understand?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_6 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_6 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_6 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">7.</b> Does your doctor talk with you about the medications you are taking at each visit?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_7 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_7 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_7 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">8.</b> Are medical staff friendly and helpful?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_8 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_8 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_8 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">9.</b> When blood tests, x-rays, or other tests are ordered, does the practice give you the results?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_9 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_9 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_9 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">10.</b> If you/family/caregiver have received care from a specialist, does your doctor seem to know about the care you received?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_10 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_10 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_10 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">11.</b> Does your doctor provide information on ways to improve your health?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_11 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_11 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_11 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">12.</b> Has your doctor asked if there are things that make it hard for you to take care of your health?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_12 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_12 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_12 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">13.</b> Have staff at the practice recommended services in your community or offered their own workshops to help improve your health (i.e., weight management groups, nutrition/meal support)?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_13 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_13 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_13 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">14.</b> Are recommendations to you/family/caregiver received (including community service and supports) to improve your health helpful?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_14 == 1} disabled />
                      <span>YES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_14 == 2} disabled />
                      <span>SOMETIMES</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_14 == 3} disabled />
                      <span>NO</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">15.</b> What is your preferred method of communication?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_15 == 1} disabled />
                      <span>Phone</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_15 == 2} disabled />
                      <span>Text</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_15 == 3} disabled />
                      <span>Email</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">16.</b> Do you consider the waiting time:</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_16 == 1} disabled />
                      <span>Brief</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_16 == 2} disabled />
                      <span>Reasonable</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_16 == 3} disabled />
                      <span>Excessive</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">17.</b> Do you prefer appointments during the morning, afternoon, evening, or weekends?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_17 == 1} disabled />
                      <span>Morning</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_17 == 2} disabled />
                      <span>Afternoon</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_17 == 3} disabled />
                      <span>Evening</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_17 == 4} disabled />
                      <span>Weekend</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }}>
                    <p className="mb-0"><b className="me-2">18.</b> Which weeknight would you prefer extended hours?</p>
                  </td>
                  <td>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_18 == 1} disabled />
                      <span>Monday</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_18 == 2} disabled />
                      <span>Tuesday</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_18 == 3} disabled />
                      <span>Wednesday</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_18 == 4} disabled />
                      <span>Thursday</span>
                    </div>
                    <div className="flex items-center">
                      <input className="form-check-input" type="checkbox" checked={formData?.survey_18 == 5} disabled />
                      <span>Friday</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />
          <p><b>Patient Feedback :</b> {formData?.patient_feedback}</p>
        </div>
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handleCloseWindow();
            } else {
              setFormView();
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handlePrint();
            } else {
              handleFormPrint(formViewId);
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
              <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
              <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <circle cx={392} cy={184} r={24} fill="currentColor" /> 
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
